import clsx from "clsx";

const TONE: Record<string, string> = {
  GET:    "border-sev-good/40 bg-sev-good/10 text-sev-good",
  POST:   "border-accent/40 bg-accent/10 text-accent",
  PUT:    "border-sev-watch/40 bg-sev-watch/10 text-sev-watch",
  PATCH:  "border-sev-watch/40 bg-sev-watch/10 text-sev-watch",
  DELETE: "border-sev-high/40 bg-sev-high/10 text-sev-high",
};

/** Coloured pill for an HTTP method. Falls back to a neutral chip. */
export function MethodBadge({ method }: { method: string | null | undefined }) {
  if (!method) return <span className="text-fg-subtle text-xs">\u2014</span>;
  const m = method.toUpperCase();
  return (
    <span className={clsx(
      "inline-flex rounded-md border px-1.5 py-0.5 text-[10px] font-semibold tracking-wide",
      TONE[m] ?? "border-border bg-surface-3 text-fg-muted",
    )}>{m}</span>
  );
}
